import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/** PHP has no separate welcome page — redirect to game. */
export default function WelcomePage() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/game', { replace: true });
  }, [navigate]);

  return null;
}
